import { useMemo } from 'react';
import * as R from 'ramda';

import {
  FormInstanceFieldItem,
  PciModuleDistress,
  PciModuleInspectionOption,
} from '@atom/types/form';

import { HAS_NO_DISTRESS_OPTION } from './NbiInspection';

import classes from './pci.module.css';

interface Props {
  field: FormInstanceFieldItem;
}

const NbiSummary = ({ field }: Props) => {
  const distressSummary = R.pathOr<PciModuleDistress>(
    null,
    ['pci', 'distress', 0],
    field,
  );

  const distressSummaryOption = useMemo<PciModuleInspectionOption>(() => {
    if (field.pci?.hasNoDistress) {
      return HAS_NO_DISTRESS_OPTION;
    }

    if (!distressSummary || !field?.pci?.options) {
      return null;
    }

    return field.pci.options.distress.find(
      option => option.name === distressSummary.distress,
    );
  }, [field]);

  return (
    distressSummaryOption && (
      <div className={classes.inspectionContainer}>
        <div className={classes.subtitle}>Inspection</div>
        <div className={classes.label}>
          Which description is most appropriate for this item's condition?
        </div>
        <div className={classes.distressContainer}>
          <div
            className={classes.distressLabel}
          >{`${distressSummaryOption.points} - ${distressSummaryOption.name}`}</div>
          <div className={classes.distressDescription}>
            {distressSummaryOption.description}
          </div>
          {distressSummaryOption.descriptionSubtexts &&
            distressSummaryOption.descriptionSubtexts.map(subtext => (
              <div key={subtext} className={classes.distressSubtextContainer}>
                <div className={classes.distressBullet} />
                <div className={classes.distressSubtext}>{subtext}</div>
              </div>
            ))}
        </div>
      </div>
    )
  );
};

export default NbiSummary;
